import React from 'react';
import styles from '../../Dashboard.module.css';
import HeaderAvatar from '../../../Avatar/HeaderAvatar';
import Logo from '../../../Logo/Logo';
import AppLauncherModal from '../../../AppLauncher/AppLauncherModal';
import DarkModeToggle from '../../../DarkModeToggle';

const Header = ({
  viewMode,
  onChangeView,
  onToggleSidebar,
  sortDropdownOpen,
  onToggleSort,
  sortOptions = [],
  selectedSort,
  onSelectSort,
}) => {
  // Close dropdown on outside click
  const dropdownRef = React.useRef(null);
  React.useEffect(() => {
    function handleClick(e) {
      if (sortDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onToggleSort?.(); // toggle will close
      }
    }
    if (sortDropdownOpen) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sortDropdownOpen, onToggleSort]);

  return (
    <header className={styles.header}>
      <div className={styles['header-content']}>
        <div className={styles['header-left']}>
          <button className={styles['header-toggle-btn']} onClick={onToggleSidebar} aria-label="Toggle sidebar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className={styles['header-toggle-icon']}><path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" /></svg>
          </button>
          <div className={styles['header-brand']}>
            <Logo className={styles['header-brand-icon']} />
            <span className={styles['header-brand-text']}>MindMap</span>
          </div>
        </div>
        <div className={styles['header-right']}>
          <div className={styles['header-sort-container']} ref={dropdownRef}>
            <button
              onClick={onToggleSort}
              className={`${styles['header-sort-btn']} ${sortDropdownOpen ? styles['header-sort-btn-active'] : ''}`}
            >
              <svg className={styles['header-sort-icon']} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 7h18M6 12h12M10 17h4" />
              </svg>
              {selectedSort?.label || 'Sort'}
              <svg className={`${styles['header-sort-chevron']} ${sortDropdownOpen ? styles['header-sort-chevron-rotated'] : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {sortDropdownOpen && (
              <div className={styles['header-sort-dropdown']}>
                {sortOptions.map(opt => {
                  const active = selectedSort?.id === opt.id;
                  return (
                    <button
                      key={opt.id}
                      onClick={() => onSelectSort?.(opt)}
                      className={`${styles['header-sort-option']} ${active ? styles['header-sort-option-active'] : ''}`}
                    >
                      <span>{opt.label}</span>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          <div className={styles['header-view-toggle']}>
            <button
              onClick={() => onChangeView('grid')}
              className={`${styles['header-view-btn']} ${viewMode === 'grid' ? styles['header-view-btn-active'] : ''}`}
              title="Grid view"
            >
              <svg className={styles['header-view-icon']} viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 3h7v7H3V3zm0 11h7v7H3v-7zm11-11h7v7h-7V3zm0 11h7v7h-7v-7z" />
              </svg>
            </button>
            <div className={styles['header-view-divider']}></div>
            <button
              onClick={() => onChangeView('list')}
              className={`${styles['header-view-btn']} ${viewMode === 'list' ? styles['header-view-btn-active'] : ''}`}
              title="List view"
            >
              <svg className={styles['header-view-icon']} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
              </svg>
            </button>
          </div>
          <AppLauncherModal/>
          <DarkModeToggle />
          <HeaderAvatar />
        </div>
      </div>
    </header>
  );
};

export default Header;
